import React, {  useState } from "react";
import { ColumnDirective, ColumnsDirective,Grid, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import Api from "../../Hooks/Api";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import useValidateRole from "../../Hooks/useValidateRole";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import { MDBDataTable } from "mdbreact";
import "./tabs.css";
import swal from "sweetalert";
import { Progress } from "reactstrap";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
var dateFormat = require("dateformat");
const Projects = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [InstitutionDocuments, setInstitutionDocuments] = useState([]);
  const [ProjectSponsers, setProjectSponsers] = useState({});
  const [ProjectProgress, setProjectProgress] = useState({});
  const [view, setview] = useState(false);
  const [projectId, setprojectId] = useState("");
  const [update, setUpdate] = useState(false);
  const [PageRole, setPageRole] = useState("Projects");
  const ProjectStatus = useFetchData("api/ProjectStatus");
  const Institutions = useFetchData("api/DashBoard/ApprovedInstitutions");
  const url = "api/Projects";
  let grid= Grid | null;
  const dataurl = process.env.REACT_APP_BASE_URL + 'api/Projects/AllProjects';
  const [notimporteddataList, setnotimporteddataList] = useState([]);
  const [uploadresponse, setuploadresponse] = useState({});
  const [Import, setImport] = useState(false);
  const [state, setState] = useState([]);
  const [message, setmessage] = useState("");
  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const fetchData = () => {
    setState([]);
    Api.get(url)
      .then(function (response) {
        setState(response.data)
      })
      .catch(function (error) {
      })
      .then(function () {
        // always executed
      })
  };
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const SaveUploads = (url) => {
    const data = new FormData();
    for (var x = 0; x < selectedFile.length; x++) {
      data.append("file", selectedFile[x]);
    }
    Api.post(url, data, {
        // receive two parameter endpoint url ,form data
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
      .then((res) => {
        if (res.status == "200") {
          setmessage("Uploaded successfully");
          setuploadresponse(res.data);
          setnotimporteddataList(res.data.notimporteddataList);
        }
      })
      .catch((err) => {
        console.log(err);
        setmessage("upload fail");
      });
  };
  const UploadStudents = (event) => {
    event.preventDefault();
    if (inputs.institutionId) {
      if (selectedFile) {
       
          SaveUploads("/api/ImportStudents/Projects/" + inputs.institutionId);
       
      } else {
        setmessage("Select a file to upload");
      }
    } else {
      setmessage("Select Institution to continue");
    }
  };
  const onChangeHandler = (event) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
    }
  };
  const exportToCSV = (csvData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
 
  const handleOpenModal = (event) => {
    //event.persist();
    setInputs({});
    setProjectProgress({});
    setProjectSponsers({});
    setOpen(true);
  };

  const handleSelectChange = (UserGroup, actionMeta) => {
    setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleProjectSponsersInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setProjectSponsers((ProjectSponsers) => ({
      ...ProjectSponsers,
      [name]: value,
    }));
  };
  const handleProjectProgressInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setProjectProgress((ProjectProgress) => ({
      ...ProjectProgress,
      [name]: value,
    }));
  };
  const handleProjectProgressSelectChange = (UserGroup, actionMeta) => {
    setProjectProgress((ProjectProgress) => ({
      ...ProjectProgress,
      [actionMeta.name]: UserGroup.value,
    }));
  };
  const handleEdit = () => {
    if (inputs.id) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.id) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleprojectProgressSelect = (k, event) => {
    setProjectProgress({});
    setProjectProgress(k);
    setProjectSponsers((ProjectSponsers) => ({
      ...ProjectSponsers,
      ["projectId"]: projectId,
    }));
    setProjectProgress((ProjectProgress) => ({
      ...ProjectProgress,
      ["projectId"]: projectId,
    }));
  };
  const handleprojectSponsersSelect = (k, event) => {
    setProjectSponsers({});
    setProjectSponsers(k);
    setProjectSponsers((ProjectSponsers) => ({
      ...ProjectSponsers,
      ["projectId"]: projectId,
    }));
    setProjectProgress((ProjectProgress) => ({
      ...ProjectProgress,
      ["projectId"]: projectId,
    }));
  };
 
  const handleNewSponsersClick = () => {
    setUpdate(false);
    setview(false);
  };
  const handleSponsersUpdateClick = () => {
    if (ProjectSponsers.id) {
      setUpdate(true);
      setview(false);
    } else {
      alert("Select record to update");
    }
  };
  const handleprojectProgressUpdateClick = () => {
    if (ProjectProgress.id) {
      setUpdate(true);
      setview(false);
    } else {
      alert("Select record to update");
    }
  };
  const handleSelect = (k, event) => {
 
    setInputs(k.data);
    fetchsetInstitutionsDocuments(k.data.id)
    setprojectId(k.data.id);
    fetchProjectDetails("api/Projects/" + k.data.id);
    setProjectSponsers((ProjectSponsers) => ({
      ...ProjectSponsers,
      ["projectId"]: k.data.id,
    }));
    setProjectProgress((ProjectProgress) => ({
      ...ProjectProgress,
      ["projectId"]: k.data.id,
    }));
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
    setUpdate(false);
    setInputs({});
  };
  const HandleSaveSponsers = () => {
    useSave("api/ProjectSponsers", ProjectSponsers);
    grid.refresh();
  };
  const HandleProjectProgress = () => {
    useSave("api/ProjectProgresses", ProjectProgress);
    grid.refresh();
  };
  const SaveProject = (url = ``, inputs = {}) => {
    Api.post(url, JSON.stringify(inputs))
      .then((response) => {
        if (response.status == "200") {
          if (response.data.id) {
            setProjectSponsers((ProjectSponsers) => ({
              ...ProjectSponsers,
              ["projectId"]: response.data.id,
            }));
            setProjectProgress((ProjectProgress) => ({
              ...ProjectProgress,
              ["projectId"]: response.data.id,
            }));
            swal("", "saved", "success");
            fetchData();
          }


        } else {
          swal("", response.data.msg, "error");

        }

      }, (error) => {
        swal("", "Failed", "error");
      });

  };
  const handlenextFirstTab = (e) => {
    e.preventDefault();
    if (update) {
      HandleUpdate(url + "/" + inputs.id, inputs);
    } else {
      SaveProject(url, inputs);
    }

    // document.getElementById("profile-tab").click();
  };
  const handlenextSecondTab = (e) => {
    e.preventDefault();
    if (update) {
      HandleUpdate(
        "api/ProjectSponsers/" + ProjectSponsers.id,
        ProjectSponsers
      );
    } else {
      HandleSaveSponsers();
    }
    // document.getElementById("contact-tab").click();
  };

  const HandleUpdate = (url, data = {}) => {
    useUpdate(url, data);
    grid.refresh();
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(
        "api/ProjectProgresses/" + ProjectProgress.id,
        ProjectProgress
      );
    } else {
      HandleProjectProgress();
    }
  };
  const handleCloseImportModal = () => {  
    grid.refresh();
    setImport(false);
    setloaded("");
    setselectedFile("");
    setmessage("");
  };
  const CallDeletehook = () => {
    useDelete(url + "/" + inputs.id);
    grid.refresh();
  };
  const HandelDelete = () => {
    if (inputs.id) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ProjectProgressColumnData = [
    {
      label: "ProgressDate",
      field: "ProgressDate",
      sort: "asc",
    },
    {
      label: "Stage",
      field: "Stage",
      sort: "asc",
    },
    {
      label: "ProjectStatus",
      field: "ProjectStatus",
      sort: "asc",
    },
    {
      label: "Narration",
      field: "Narration",
      sort: "asc",
    },
  ];
  const ProjectSponsersColumnData = [
    {
      label: "Name",
      field: "name",
      sort: "asc",
    },
    {
      label: "PercentageSponsered",
      field: "percentageSponsered",
      sort: "asc",
    },
    {
      label: "Mobile",
      field: "Mobile",
      sort: "asc",
    },
    {
      label: "Email",
      field: "Email",
      sort: "asc",
    },
    {
      label: "Address",
      field: "Address",
      sort: "asc",
    },
    {
      label: "Website",
      field: "Website",
      sort: "asc",
    },
  ];
  let ProjectSponsersData = [];
  let ProjectProgressData = [];
  if (inputs.projectProgress) {
    inputs.projectProgress.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleprojectProgressSelect(k),
        ProgressDate: dateFormat(k.progressDate, "mediumDate"),
        Stage: k.stage,
        Email: k.email,
        ProjectStatus: k.projectStatus ? k.projectStatus.name : "N/A",
        Narration: k.narration,
      };
      ProjectProgressData.push(Rowdata);
    });
  }
  if (inputs.projectSponsers) {
    inputs.projectSponsers.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleprojectSponsersSelect(k),
        Website: k.website,
        Address: k.address,
        Email: k.email,
        Mobile: k.mobile,
        percentageSponsered: k.percentageSponsered,
        name: k.name,
      };
      ProjectSponsersData.push(Rowdata);
    });
  }
  const handleImport = () => {
    setImport(true);
  };
  const fetchsetInstitutionsDocuments = (id) => {
    Api.get("api/Projects/ProjectsDocument/" + id )
      .then(function (response) {
        setInstitutionDocuments(response.data);       
               
      })
      .catch(function (error) {
      })
      .then(function () {
        // always executed
      })
  };
  const onClickDocumentHandler = (event) => {
    event.preventDefault();
    if(inputs.dosumentdescription){    
    if (selectedFile) {
      const data = new FormData();

      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      let dosumentdescription=inputs.dosumentdescription.split(" ").join("-").toLowerCase();
      let desc=dosumentdescription.split("/").join("-").toLowerCase();
      Api.post("/api/Projects/ProjectsDocument/"+inputs.id+"/"+desc, data, {
        // receive two parameter endpoint url ,form data
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200") {
            setmessage("Uploaded successfully");
            fetchsetInstitutionsDocuments(inputs.id);
       
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  }else{
    setmessage("Document Description is required");
  }
  };
  const fetchProjectDetails = (url) => {
    Api.get(url)
      .then(function (response) {
        if (response.data.length > 0) {
          setInputs(response.data[0]);
        }
      })
      .catch(function (error) {
      })
      .then(function () {
        // always executed
      })


  };

  const ViewDocument=(path)=>{
    let uri = process.env.REACT_APP_BASE_URL+"api/" + path;
    window.open(uri, '_blank').focus();
  }
  const ProjectStatusOptions = [];
  if (ProjectStatus.response) {
    ProjectStatus.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      ProjectStatusOptions.push(col);
    });
  }

  const InstitutionsOptions = [];
  if (Institutions.response) {
    Institutions.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      InstitutionsOptions.push(col);
    });
  }
  let documentsdata=[];
  if(InstitutionDocuments.length > 0){
    InstitutionDocuments.forEach((k) => {
   
    const Rowdata = {
      
      description: k.description,
      created_At: k.created_At,
      view:<span className="text-primary"  onClick={() =>ViewDocument(k.path)}>View</span>
    };
    documentsdata.push(Rowdata);
  });
  
} 
  const documentsColumnData= [
    {
      label: "Description",
      field: "description",
      sort: "asc",
    },{
      label: "Date Uploaded",
      field: "created_At",
      sort: "asc",
    },{
      label: "View",
      field: "view",
      sort: "asc",
    }]
  const ActionsBtn = () => {
    return (
      <div>
        {useValidateRole(PageRole, "Edit") ? (
          <button
            className="btn btn-success p-2"
            type="button"
            onClick={handleEdit}
          >
            Update
          </button>
        ) : null}
        &nbsp; &nbsp;
        {useValidateRole(PageRole, "Remove") ? (
          <button onClick={HandelDelete} className="btn btn-danger p-2">
            Delete
          </button>
        ) : null}
        &nbsp;
        <button
          className="btn btn-warning p-2"
          type="button"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </div>
    );
  };
  const styles = {
    control: (base) => ({
      ...base,
      minHeight: "12px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Projects</li>
      </ol>
      <h1 class="page-header mb-3">Projects</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
              <button
                onClick={handleOpenModal}
                className="btn btn-success p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "View") ? (
              <button
                onClick={handleView}
                className="btn btn-success p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; View &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "Edit") ? (
              <button
                onClick={handleEdit}
                className="btn btn-info p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Edit &nbsp;
              </button>
            ) : null}
                { window.sessionStorage.getItem("securitygroup") ===
            "Institution Administrator" ?
              <button
                onClick={handleImport}
                className="btn btn-info p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp;Import Projects &nbsp;
              </button>
            : null}
            {useValidateRole(PageRole, "Remove") ? (
              <button
                onClick={HandelDelete}
                className="btn btn-danger p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Delete &nbsp;
              </button>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
          <GridComponent ref={g => grid = g}
              allowPaging={true}
              allowResizing={true}
              allowFiltering={true}
              allowTextWrap={true}
              rowSelected={(args) => {
                handleSelect(args);
              }}
              dataSource={new DataManager({
                adaptor: new UrlAdaptor(),
                crossDomain: true,
                url: dataurl,
                headers: [{
                  Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                }]
              })
              }>
              <ColumnsDirective>               
                <ColumnDirective field='description' headerText='Description' />
                <ColumnDirective field='projectStatus' headerText='Status' />
                <ColumnDirective field='startDate' type='date' format='dd/MM/yyyy' headerText='StartDate'  />             
                <ColumnDirective field='endDate' type='date' format='dd/MM/yyyy' headerText='EndDate'  />             
                <ColumnDirective field='expectedEndDate' type='date' format='dd/MM/yyyy' headerText='ExpectedEndDate'  />             
                <ColumnDirective field='value' headerText='value' type='number' format='n2'  />             
                <ColumnDirective field='institution' headerText='Institution' />
              </ColumnsDirective>
              <Inject services={[Page, Sort, Resize, Filter]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <Modal visible={open} width="90%" height="50%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <div
            className="row"
            style={{
              background: "yellow",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <div class="col-xs-12 center-block text-center">
              {view ? (
                <h3 className="text-center font-weight-bold">
                  <span>
                    {" "}
                    {inputs.description}
                    {inputs.institution
                      ? "(" + inputs.institution.name + ")"
                      : ""}
                  </span>
                </h3>
              ) : (
                  <h3 className="text-center font-weight-bold">New Project</h3>
                )}
            </div>
          </div>

          <div>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  Project Details
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  Project Sponsers
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="contact-tab"
                  data-toggle="tab"
                  href="#contact"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  Project Progress
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="Documents-tab"
                  data-toggle="tab"
                  href="#Documents"
                  role="tab"
                  aria-controls="Documents"
                  aria-selected="false"
                >
                  Documents
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <form className="form-horizontal" onSubmit={handlenextFirstTab}>
                  <div
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                    className="row"
                  >
                    <div
                      className="col-sm-5"
                      style={{ border: "1px solid", marginTop: "2px" }}
                    >
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="font-weight-bold">Project Code:</td>
                            <td>
                              {" "}
                              {view ? (
                                inputs.code
                              ) : (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="code"
                                    required
                                    placeholder
                                    value={inputs.code || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-bold">Description:</td>
                            <td>
                              {view ? (
                                inputs.description
                              ) : (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="description"
                                    required
                                    value={inputs.description || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-bold">StartDate:</td>
                            <td>
                              {view ? (
                                inputs.startDate ? (
                                  dateFormat(inputs.startDate, "mediumDate")
                                ) : (
                                    "N/A"
                                  )
                              ) : (
                                  <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    name="startDate"
                                    required
                                    value={
                                      inputs.startDate
                                        ? dateFormat(inputs.startDate, "isoDate")
                                        : ""
                                    }
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>

                          <tr>
                            <td className="font-weight-bold">
                              Expected Duration (Months):
                            </td>
                            <td>
                              {view ? (
                                inputs.expectedDuration
                              ) : (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="expectedDuration"
                                    required
                                    value={inputs.expectedDuration || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      className="col-sm-5"
                      style={{
                        borderTop: "1px solid",
                        borderBottom: "1px solid",
                        marginTop: "2px",
                      }}
                    >
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="font-weight-bold">Instituition:</td>
                            <td>
                              {view ? (
                                inputs.institution ? (
                                  inputs.institution.name
                                ) : (
                                    "N/A"
                                  )
                              ) : (
                                  <Select
                                    styles={styles}
                                    name="institutionId"
                                    value={InstitutionsOptions.filter(
                                      (option) =>
                                        option.value === inputs.institutionId
                                    )}
                                    onChange={handleSelectChange}
                                    options={InstitutionsOptions}
                                  />
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-bold">Status:</td>
                            <td>
                              {view ? (
                                inputs.projectStatus ? (
                                  inputs.projectStatus.name
                                ) : (
                                    ""
                                  )
                              ) : (
                                  <Select
                                    styles={styles}
                                    name="projectStatusId"
                                    value={ProjectStatusOptions.filter(
                                      (option) =>
                                        option.value === inputs.projectStatusId
                                    )}
                                    onChange={handleSelectChange}
                                    options={ProjectStatusOptions}
                                  />
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-bold">EndDate:</td>
                            <td>
                              {view ? (
                                inputs.endDate ? (
                                  dateFormat(inputs.endDate, "mediumDate")
                                ) : (
                                    "N/A"
                                  )
                              ) : (
                                  <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    name="endDate"
                                    required
                                    value={
                                      inputs.endDate
                                        ? dateFormat(inputs.endDate, "isoDate")
                                        : ""
                                    }
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="font-weight-bold">Project Value:</td>
                            <td>
                              {view ? (
                                inputs.value
                              ) : (
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="value"
                                    required
                                    value={inputs.value || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      className="col-sm-2"
                      style={{
                        borderRight: "1px solid",
                        borderTop: "1px solid",
                        borderBottom: "1px solid",
                        marginTop: "2px",
                      }}
                    ></div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      "justify-content": "flex-end",
                      marginRight: "10px",
                      marginTop: "2px",
                    }}
                  >
                    {view ? (
                      <ActionsBtn />
                    ) : (
                        <div class="d-flex flex-row">
                          <button className="btn btn-success p-2" type="submit">
                            Save
                        </button>
                        &nbsp;
                          <button
                            className="btn btn-warning p-2"
                            type="button"
                            onClick={handleCloseModal}
                          >
                            Close
                        </button>
                        </div>
                      )}
                  </div>
                </form>
              </div>
              <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <form
                  className="form-horizontal"
                  onSubmit={handlenextSecondTab}
                >
                  {view ? (
                    <div className="row">
                      <div className="col-sm-12">
                        <div class="d-flex flex-row">
                          <button
                            className="btn btn-success p-2"
                            type="button"
                            onClick={handleNewSponsersClick}
                          >
                            New
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-secondary p-2"
                            type="button"
                            onClick={handleSponsersUpdateClick}
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <MDBDataTable
                          striped
                          bordered
                          hover
                          noBottomColumns
                          searching={false}
                          displayEntries={false}
                          paging={false}
                          data={{
                            columns: ProjectSponsersColumnData,
                            rows: ProjectSponsersData,
                          }}
                          info
                        />
                      </div>
                    </div>
                  ) : (
                      <div
                        style={{ marginLeft: "10px", marginRight: "10px" }}
                        className="row"
                      >
                        <div
                          className="col-sm-5"
                          style={{ border: "1px solid", marginTop: "2px" }}
                        >
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">Name:</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="name"
                                    value={ProjectSponsers.name || ""}
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Address:</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="address"
                                    required
                                    value={ProjectSponsers.address || ""}
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Email:</td>
                                <td>
                                  <input
                                    type="email"
                                    className="form-control form-control-sm"
                                    name="email"
                                    required
                                    value={ProjectSponsers.email || ""}
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="col-sm-5"
                          style={{
                            borderTop: "1px solid",
                            borderBottom: "1px solid",
                            marginTop: "2px",
                          }}
                        >
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">
                                  Percentage Sponsered:
                              </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="percentageSponsered"
                                    required
                                    value={
                                      ProjectSponsers.percentageSponsered || ""
                                    }
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Mobile:</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="mobile"
                                    required
                                    value={ProjectSponsers.mobile || ""}
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Website:</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="website"
                                    value={ProjectSponsers.website || ""}
                                    onChange={handleProjectSponsersInputChange}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="col-sm-2"
                          style={{
                            borderRight: "1px solid",
                            borderTop: "1px solid",
                            borderBottom: "1px solid",
                            marginTop: "2px",
                          }}
                        ></div>
                      </div>
                    )}

                  <div
                    style={{
                      display: "flex",
                      "justify-content": "flex-end",
                      marginRight: "10px",
                      marginTop: "2px",
                    }}
                  >
                    {view ? (
                      <button
                        className="btn btn-warning p-2"
                        type="button"
                        onClick={handleCloseModal}
                      >
                        Close
                      </button>
                    ) : (
                        <div class="d-flex flex-row">
                          <button className="btn btn-success p-2" type="submit">
                            Save
                        </button>
                        &nbsp;
                          <button
                            className="btn btn-warning p-2"
                            type="button"
                            onClick={handleCloseModal}
                          >
                            Close
                        </button>
                        </div>
                      )}
                  </div>
                </form>
              </div>
              <div
                class="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                {view ? (
                  <div className="row">
                    <div className="col-sm-12">
                      <div class="d-flex flex-row">
                        <button
                          className="btn btn-success p-2"
                          type="button"
                          onClick={handleNewSponsersClick}
                        >
                          New
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-secondary p-2"
                          type="button"
                          onClick={handleprojectProgressUpdateClick}
                        >
                          Edit
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <MDBDataTable
                        striped
                        bordered
                        hover
                        noBottomColumns
                        searching={false}
                        displayEntries={false}
                        paging={false}
                        data={{
                          columns: ProjectProgressColumnData,
                          rows: ProjectProgressData,
                        }}
                        info
                      />
                    </div>
                  </div>
                ) : (
                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                      <div
                        style={{ marginLeft: "10px", marginRight: "10px" }}
                        className="row"
                      >
                        <div
                          className="col-sm-5"
                          style={{ border: "1px solid", marginTop: "2px" }}
                        >
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">
                                  Project Stage:
                              </td>
                                <td>
                                  {view ? (
                                    ProjectProgress.stage
                                  ) : (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="stage"
                                        required
                                        value={ProjectProgress.stage || ""}
                                        onChange={handleProjectProgressInputChange}
                                      />
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Progress Date:
                              </td>
                                <td>
                                  {view ? (
                                    ProjectProgress.progressDate
                                  ) : (
                                      <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="progressDate"
                                        required
                                        value={
                                          ProjectProgress.progressDate
                                            ? dateFormat(
                                              ProjectProgress.progressDate,
                                              "isoDate"
                                            )
                                            : ""
                                        }
                                        onChange={handleProjectProgressInputChange}
                                      />
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="col-sm-5"
                          style={{
                            borderTop: "1px solid",
                            borderBottom: "1px solid",
                            marginTop: "2px",
                          }}
                        >
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">Status:</td>
                                <td>
                                  {view ? (
                                    ProjectProgress.projectStatus ? (
                                      ProjectProgress.projectStatus.name
                                    ) : (
                                        ""
                                      )
                                  ) : (
                                      <Select
                                        styles={styles}
                                        name="projectStatusId"
                                        value={ProjectStatusOptions.filter(
                                          (option) =>
                                            option.value ===
                                            ProjectProgress.projectStatusId
                                        )}
                                        onChange={handleProjectProgressSelectChange}
                                        options={ProjectStatusOptions}
                                      />
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Narration:</td>
                                <td>
                                  {view ? (
                                    ProjectProgress.narration
                                  ) : (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="narration"
                                        required
                                        value={ProjectProgress.narration || ""}
                                        onChange={handleProjectProgressInputChange}
                                      />
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="col-sm-2"
                          style={{
                            borderRight: "1px solid",
                            borderTop: "1px solid",
                            borderBottom: "1px solid",
                            marginTop: "2px",
                          }}
                        ></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          "justify-content": "flex-end",
                          marginRight: "10px",
                          marginTop: "2px",
                        }}
                      >
                        {view ? (
                          <ActionsBtn />
                        ) : (
                            <div class="d-flex flex-row">
                              <button className="btn btn-success p-2" type="submit">
                                Submit
                          </button>
                          &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                          </button>
                            </div>
                          )}
                      </div>
                    </form>
                  )}
              </div>
              <div
                class="tab-pane fade"
                id="Documents"
                role="tabpanel"
                aria-labelledby="Documents-tab"
              >
                <form className="form-horizontal" onSubmit={HandleSubmit}>
                  <div
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                    className="row"
                  >
                  
               <div className="col-sm-6">
                        <div class="form-group row m-b-15">
                          <label class="col-form-label col-md-3">Description</label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="dosumentdescription"
                              required
                              value={inputs.dosumentdescription}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                 <div className="col-sm-4">
                 <div className="form-group">
                                              <input
                                                type="file"
                                                className="form-control"
                                                name="file"
                                                onChange={onChangeHandler}
                                                accept=".xlsx, .xls, .csv"
                                              />
                                              <div class="form-group">
                                                <Progress
                                                  max="100"
                                                  color="success"
                                                  value={loaded}
                                                >
                                                  {Math.round(loaded, 2)}%
                                                </Progress>
                                              
                                              </div>

                                              <span class="upload" style={{color:"red"}}>
                                                {message}
                                              </span>
                                            </div>
                 </div>
                 <div className="col-sm-2">  <button
                                                  type="button"
                                                  class="btn btn-success "
                                                  onClick={onClickDocumentHandler}
                                                >
                                                  Upload
                                                </button></div>
             
               </div>              
                  <hr/>
                     
                      <div className="row"  style={{  marginTop: "2px" }}>
                        <div className="col-sm-12">
                          <MDBDataTable
                            striped
                            bordered
                            hover
                            noBottomColumns
                            searching={false}
                            displayEntries={false}
                            paging={true}
                            data={{
                              columns: documentsColumnData,
                              rows: documentsdata,
                            }}
                            info
                          />
                        </div>
                      </div>
                    
                     

                  <div
                    style={{
                      display: "flex",
                      "justify-content": "flex-end",
                      marginRight: "10px",
                      marginTop: "2px",
                    }}
                  >
                   
                      <div class="d-flex flex-row">                       
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
              
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* end tabs */}
        </div>
      </Modal>
      <Modal visible={Import} width="50%" height="50%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <div
            className="row"
            style={{
              background: "yellow",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <div class="col-xs-12 center-block text-center">
              <h3 className="text-center font-weight-bold">
               
                  <span> Import Projects</span>
                
              </h3>
            </div>
          </div>

          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <form className="form-horizontal" onSubmit={HandleSubmit}>
                  <br />
                  <div className=" row">
                    <p>
                      Download Template here{" "}
                    
                        <a
                          href={
                            process.env.REACT_APP_BASE_URL +
                            "api/GenerateImportStudentsExcel/Projects/"+window.sessionStorage.getItem("InstitutionId")
                          }
                        >
                          Donwload
                        </a>
                     
                    </p>
                  </div>
                  <div className=" row">
                    <div className="col-sm">
                      <div class="form-group row m-b-15">
                        <label class="col-form-label col-md-3">
                          Institution
                        </label>
                        <div class="col-md-9">
                          <Select
                            styles={styles}
                            name="institutionId"
                            value={InstitutionsOptions.filter(
                              (option) => option.value === inputs.institutionId
                            )}
                            onChange={handleSelectChange}
                            options={InstitutionsOptions}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" row">
                    <div className="col-sm">
                      <div class="form-group row m-b-15">
                        <label class="col-form-label col-md-3">Upload </label>
                        <div class="col-md-9">
                          <div className="form-group">
                            <input
                              type="file"
                              className="form-control"
                              name="file"
                              onChange={onChangeHandler}
                              accept=".xlsx, .xls, .csv"
                            />
                            <div class="form-group">
                              <Progress
                                max="100"
                                color="success"
                                value={loaded}
                              >
                                {Math.round(loaded, 2)}%
                              </Progress>
                              <button
                                type="button"
                                class="btn btn-success "
                                onClick={UploadStudents}
                              >
                                Import now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" row">
                    {message == "Uploaded successfully" ? (
                      uploadresponse.importedTotal == 0 ? (
                        <div className="col-sm bg-danger">
                          <p className="text-white">
                            Upload Failed.No record was saved
                          </p>
                        </div>
                      ) : (
                          <div className="col-sm bg-success">
                            <div className="col-sm bg-success">
                              <p className="text-white">
                                Saved Record(s): ({uploadresponse.importedTotal})
                            </p>
                            </div>
                            <div className="col-sm bg-danger">
                              <p className="text-white">
                                Not Saved Record(s): (
                              {uploadresponse.notImportedTotal} ) &nbsp;&nbsp;
                              {uploadresponse.notImportedTotal == 0 ? null : (
                                  <b
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      exportToCSV(
                                        uploadresponse.notimporteddataList,
                                        "NotImported"
                                      )
                                    }
                                  >
                                    click here to Download
                                  </b>
                                )}
                              </p>
                            </div>
                          </div>
                        )
                    ) : null}
                    {message == "upload fail" ? (
                      <div className="col-sm bg-danger">
                        <p className="text-white">
                          Uploaded Failed No record was saved
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div
                    className=" row"
                    style={{ display: "flex", "justify-content": "flex-end" }}
                  >
                    <div class="d-flex flex-row">
                      <button
                        className="btn btn-warning p-2"
                        type="button"
                        onClick={handleCloseImportModal}
                      >
                        Close
                      </button>
                    </div>
                    <br />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Projects;
